// extracted by mini-css-extract-plugin
module.exports = {"paginator":"styles_paginator__a3KHe","btnPagination":"styles_btnPagination__gVWMD"};